import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type {
  InterventionState,
  InterventionListState,
  singleElementState,
} from "@/types/store";

const InterventiosnListState: InterventionListState = {
  data: [],
  data_completed: [],
  count_completed: 0,
  error: null,
  loading: false,
  count: 0,
};

const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};
export const interventionState: InterventionState = {
  interventions: InterventiosnListState,
  intervention: singleElementSate,
};

export const BexSupportModule = {
  namespaced: true,
  state: interventionState,
  actions,
  mutations,
  getters,
};
